export const MEMO_CARD_BASE_CLASSES =
  "relative group flex flex-col justify-start items-start bg-card w-full px-4 py-3 mb-2 gap-2 text-card-foreground rounded-lg border border-border transition-colors";

export const RELATIVE_TIME_THRESHOLD_MS = 1000 * 60 * 60 * 24;
